import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { ParameterField } from '../ParameterField';
import GroupingParameterField from '../GroupingParameterField';
import SelectField from '../SelectField';
import BooleanField from '../BooleanField';

export interface IGraphOptionsValue {
    showGraph?: boolean;
    graphOption?: string;
}

export default function GraphOptions(props: {
    value: IGraphOptionsValue;

    onChange(value: IGraphOptionsValue): void;
}) {
    const getValueCopy = (): IGraphOptionsValue => {
        return (props.value != null ? $.extend(true, {}, props.value) : {}) as IGraphOptionsValue;
    };

    const processValueChange = (value: IGraphOptionsValue) => {
        if (typeof props.onChange === 'function') {
            props.onChange(value);
        }
    };

    const handleShowGraphChange = (value: boolean) => {
        const obj = getValueCopy();

        obj.showGraph = value;
        processValueChange(obj);
    };

    const handleGraphOption = (value: string) => {
        const obj = getValueCopy();

        obj.graphOption = value;
        processValueChange(obj);
    };

    const value = props.value;
    const graphOption = value.graphOption || 'ShowValueBelow';

    let graphOptionsElement: React.JSX.Element;

    if (value.showGraph) {
        graphOptionsElement = (
            <ParameterField title={'How to show value'} clearable={false}>
                <SelectField value={graphOption} onChange={handleGraphOption}>
                    <option value={'HideValue'}>{'Hide Value'}</option>
                    <option value={'ShowValueAbove'}>{'Show Value Above'}</option>
                    <option value={'ShowValueBelow'}>{'Show Value Below'}</option>
                </SelectField>
            </ParameterField>
        );
    }

    return (
        <GroupingParameterField title={'Graph Options'}>
            <ParameterField noTitle={true} clearable={false}>
                <BooleanField
                    title={'Show Graph'}
                    value={value.showGraph}
                    allowNull={false}
                    onChange={handleShowGraphChange}
                />
            </ParameterField>

            {graphOptionsElement}
        </GroupingParameterField>
    );
}

